"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _isNumber = _interopRequireDefault(require("lodash/isNumber"));
var _get = _interopRequireDefault(require("lodash/get"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _BrixelIcon = _interopRequireDefault(require("../BrixelIcon"));
var _helper = require("../../utils/helper");
var _DebounceHook = _interopRequireDefault(require("../DebounceHook"));
var _BrixelButtonPrimary = _interopRequireDefault(require("../BrixelButtonPrimary"));
var _BrixelButtonText = _interopRequireDefault(require("../BrixelButtonText"));
var _BrixelTooltip = _interopRequireDefault(require("../BrixelTooltip"));
var _translation = _interopRequireDefault(require("../../Translation/translation"));
var _reactRedux = require("react-redux");
var _BrixelAmount = _interopRequireDefault(require("./BrixelAmount"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// eslint-disable-next-line react/display-name
const BrixelInputText = /*#__PURE__*/_react.default.forwardRef((props, refs) => {
  const {
    autofocus = false,
    className = '',
    classNameInput = '',
    currency,
    disableAutocomplete = false,
    disableDelay = false,
    disabled = false,
    formatType = 'skip',
    generateValue = null,
    iconLeft = '',
    input,
    inputMode = 'text',
    isLoading = false,
    isLoadingColorClass = 'Dark700',
    label = null,
    labelLeft = null,
    lang = 'en',
    large = false,
    maxDate = '',
    maxLength = 524288,
    maxLengthNum = 10000000000000,
    message = {
      help: null,
      error: null
    },
    meta = {
      dirty: false,
      invalid: false
    },
    minDate = '',
    minLengthNum = 0,
    modal,
    normalizeValue = null,
    onClear = null,
    onKeyDown = () => '',
    onKeyUp = () => '',
    placeholder = '',
    showError = true,
    showIconValidation = true,
    showPassword = false,
    showStrongPassword = false,
    tooltip,
    translations,
    type = 'text',
    unit = null
  } = props;
  const [currentValue, setCurrentValue] = (0, _react.useState)(input.value);
  const [showPasswordState, setShowPasswordState] = (0, _react.useState)(false);
  const [showErrorState, setShowErrorState] = (0, _react.useState)(showError);
  const [unitWidth, setUnitWidth] = (0, _react.useState)(0);
  const [isFocused, setIsFocused] = (0, _react.useState)(false);
  const [getValue] = (0, _react.useState)((0, _get.default)(input, 'value', null) ? (0, _get.default)(input, 'value', '') : '');
  const localWindow = typeof window !== 'undefined' ? window : null;
  const time = disableDelay ? 150 : 500;
  const debouncedSearchTerm = (0, _DebounceHook.default)(currentValue, time);
  const inputContainerRef = (0, _react.useRef)(null);
  const ref = refs || _react.default.useRef();
  (0, _react.useEffect)(() => {
    if (input.onChange && !disableDelay) input.onChange(currentValue);
  }, [debouncedSearchTerm]);
  (0, _react.useEffect)(() => {
    if (input.onChange && disableDelay) input.onChange(currentValue);
  }, [currentValue]);
  (0, _react.useEffect)(() => {
    setShowPasswordState(showPassword);
  }, [showPassword]);
  (0, _react.useEffect)(() => {
    if (currentValue !== input.value) {
      setCurrentValue(input.value);
    }
  }, [input.value]);
  const onChange = e => {
    let val = (0, _get.default)(e, 'target.value', '').replace(/(<([^>]+)>)/gi, '');
    if (formatType === 'price') {
      const num = val;
      const numObj = num.match(/\d/g);
      if (numObj) val = +numObj.join('');
    }
    if (type === 'email' && typeof val === 'string') val = val.toLowerCase().replace(/ /g, '');
    let value;
    switch (type) {
      case 'number':
        if ((0, _isNumber.default)(+val) && (!maxLengthNum || maxLengthNum && +val <= +maxLengthNum)) {
          value = val ? parseFloat(val.toString()) : val;
        } else {
          value = currentValue;
        }
        break;
      default:
        value = normalizeValue && typeof val !== 'number' ? normalizeValue(val) : val;
    }
    if (minLengthNum && showError) {
      if (type === 'number' && value && +value <= minLengthNum) setShowErrorState(false);else if (type === 'number') setShowErrorState(true);
    }
    setCurrentValue(value);
  };
  const onFocus = val => {
    if (input.onFocus) input.onFocus(val);
  };
  const onBlur = e => {
    if (input.onBlur) input.onBlur(e);
  };
  const toggleShowPassword = (0, _react.useCallback)(e => {
    e.preventDefault();
    setShowPasswordState(!showPasswordState);
  }, [showPasswordState]);
  const unitEl = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (unitEl.current) {
      const unitBoxWidth = (0, _get.default)(unitEl, 'current.clientWidth', null);
      if (unitBoxWidth) setUnitWidth(unitBoxWidth);
    }
  }, [unitEl]);
  const selInputMode = typeInputMode => {
    let mode;
    switch (typeInputMode) {
      case 'number':
      case 'time':
        mode = 'decimal';
        break;
      default:
        mode = inputMode;
    }
    return mode;
  };
  const classPadding = (0, _react.useCallback)(() => {
    if ((0, _get.default)(input, 'value', null)) {
      if (getValue.toString().length > 0 && type === 'password' || onClear && !(0, _isEmpty.default)((0, _get.default)(input, 'value', null))) {
        return 'pr-icon';
      }
    }
    return '';
  }, [(0, _get.default)(input, 'value', null)]);
  // generate css classes fuctions
  const inputClassFunc = (0, _react.useCallback)(() => {
    let inClasses = 'desktop';
    if (!large && unit && unitWidth > 0) inClasses += ` pr-small-${unitWidth} `;
    if (large && unit && unitWidth > 0) inClasses += ` pr-small-${unitWidth + 16} `;
    if (disabled) inClasses += ' disabled ';
    if (meta.dirty && !meta.invalid && !(0, _isEmpty.default)((0, _get.default)(input, 'value', null))) inClasses += ' valid ';
    if (meta.dirty) inClasses += ' dirty-icon ';
    if (meta.dirty && meta.invalid) inClasses += ' error ';
    if (!labelLeft) inClasses += ' w-perc-100 ';
    // if (input.value && type === 'password') inClasses += ' pr-small-42 ';
    if (large) inClasses += ' large ';
    return inClasses;
  }, [localWindow, meta, disabled, unit, unitWidth, labelLeft, input.value]);
  // scroll focused input to avoid overlap with save bar
  (0, _react.useEffect)(() => {
    if (isFocused && window.innerWidth < 1024) {
      const inputEl = document.activeElement;
      if (inputEl) {
        const isInputFocused = inputEl.tagName.toString().toLowerCase() === 'input';
        const bodyScrollFunc = (0, _helper.bodyScrollclassFunc)();
        if (bodyScrollFunc) {
          const parentRect = bodyScrollFunc.getBoundingClientRect();
          const parentTop = parentRect.top;
          const rect = inputEl.getBoundingClientRect();
          const skeltonHeight = rect.bottom - parentTop;
          const avilableHeight = bodyScrollFunc.clientHeight;
          const heightDiff = avilableHeight - skeltonHeight;
          const toScroll = () => {
            let finalNumb;
            const barHeight = 80;
            if (Math.sign(heightDiff) === -1) {
              finalNumb = barHeight + Math.abs(heightDiff);
            } else {
              finalNumb = barHeight - Math.abs(heightDiff);
            }
            return finalNumb;
          };
          let scrollToCord;
          if (bodyScrollFunc) scrollToCord = bodyScrollFunc.scrollTop + toScroll();
          if (scrollToCord && isInputFocused && heightDiff < 80 && typeof bodyScrollFunc.scrollTo === 'function') {
            bodyScrollFunc.scrollTo({
              top: scrollToCord,
              behavior: 'smooth'
            });
          }
        } else if (inputEl && typeof window !== 'undefined') {
          const rect = inputEl.getBoundingClientRect();
          const skeltonHeight = rect.bottom;
          const avilableHeight = window.innerHeight;
          const heightDiff = avilableHeight - skeltonHeight;
          const toScroll = () => {
            let finalNumb;
            const barHeight = 80;
            if (Math.sign(heightDiff) === -1) {
              finalNumb = barHeight + Math.abs(heightDiff);
            } else {
              finalNumb = barHeight - Math.abs(heightDiff);
            }
            return finalNumb;
          };
          let scrollToCord;
          if (typeof document !== 'undefined' && document.scrollingElement) scrollToCord = document.scrollingElement.scrollTop + toScroll();
          if (scrollToCord && isInputFocused && heightDiff < 80 && typeof window !== 'undefined' && typeof window.scrollTo === 'function') {
            window.scrollTo({
              top: scrollToCord,
              behavior: 'smooth'
            });
          }
        }
      }
    }
  }, [isFocused]);
  const errorMessage = (0, _get.default)(meta, 'dirty', null) && (0, _get.default)(meta, 'invalid', null) && showErrorState ? (0, _get.default)(message, 'error', '') : (0, _get.default)(message, 'help', '');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, label && (/*#__PURE__*/_react.default.createElement("label", {
    className: `${tooltip ? 'wTooltip' : ''} ${disabled ? 'disabledLabel' : ''} ${large ? 'labelLarge' : ''} ${labelLeft ? 'txtText600 mb-2 dis-b' : 'brixel-label'}`,
    htmlFor: input.name
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", {
    className: `va-tb ${tooltip ? 'mr-1' : ''}`
  }, label), tooltip && (/*#__PURE__*/_react.default.createElement(_BrixelTooltip.default, {
    className: "dis-ib",
    label: tooltip.label,
    width: tooltip.width,
    description: tooltip.description,
    theme: tooltip.theme
  }))), (0, _get.default)(modal, 'info', null) && typeof modal === 'object' && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    onClick: e => modal.func ? modal.func(e) : '',
    className: "ml-2 pt-small-2",
    icon: "info",
    color: "primary"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-fl-col brixel-text-input-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f jc-b a-c"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pos-r w-perc-100"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `${labelLeft ? 'dis-f a-c jc-b row-cols-2' : 'w-perc-100'}`
  }, labelLeft && (/*#__PURE__*/_react.default.createElement("span", {
    className: `txtText900 labelLeft ${large ? 'labelLarge' : ''}`
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: `va-tb ${tooltip ? 'mr-1' : ''}`
  }, labelLeft, " "), tooltip && !label && (/*#__PURE__*/_react.default.createElement(_BrixelTooltip.default, {
    className: "dis-ib",
    label: tooltip.label,
    width: tooltip.width,
    description: tooltip.description,
    theme: tooltip.theme
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: `${type === 'password' ? `passWrapper brixel-text-input ${inputClassFunc()}` : ''} dis-f a-c pos-r input-container`,
    ref: inputContainerRef
  }, iconLeft && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    color: "text",
    saturationTxt: 900,
    className: "leftIcon pos-a-fix pl-small-10",
    icon: iconLeft
  })), input.inputType === 'search' && (/*#__PURE__*/_react.default.createElement("span", {
    className: "search-trigger"
  }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    className: "search",
    icon: "search"
  }))), formatType === 'price' ? (/*#__PURE__*/_react.default.createElement(_BrixelAmount.default, {
    className: `brixel-text-input ${type === 'password' ? '' : `${classPadding()} ${inputClassFunc()}`} ${classNameInput} ${iconLeft ? 'left-icon' : ''} ${input.inputType === 'search' ? 'search-offset' : ''}`,
    name: input.name,
    groupSeparator: currency === 'CHF' ? '\'' : '.',
    decimalSeparator: currency === 'CHF' ? '.' : ',',
    onChange: e => onChange(e),
    value: currentValue
  })) : (/*#__PURE__*/_react.default.createElement("input", {
    "data-testid": "inputText",
    role: type || 'text',
    id: input.name,
    "data-validation": false,
    autoComplete: disableAutocomplete ? 'chrome-off' : '',
    className: `brixel-text-input ${type === 'password' ? '' : `${classPadding()} ${inputClassFunc()}`} ${classNameInput} ${iconLeft ? 'left-icon' : ''} ${input.inputType === 'search' ? 'search-offset' : ''}`,
    value: currentValue,
    name: input.name,
    disabled: disabled,
    placeholder: placeholder,
    // min={type === 'number' ? '-1' : ''}
    type: showPasswordState || !type ? 'text' : type,
    onChange: e => onChange(e),
    onBlur: e => {
      onBlur(e);
      setIsFocused(false);
    },
    onFocus: e => {
      onFocus(e.target.value);
      setIsFocused(true);
    },
    max: type === 'date' ? maxDate : '',
    min: type === 'date' ? minDate : '',
    ref: ref,
    autoFocus: autofocus,
    maxLength: maxLength,
    onKeyDown: e => onKeyDown(e),
    onKeyUp: e => onKeyUp(e),
    pattern: type === 'number' || inputMode === 'decimal' ? '\\d*' : '',
    inputMode: selInputMode(type) || 'text',
    onWheel: e => e.currentTarget.blur()
  })), placeholder && (/*#__PURE__*/_react.default.createElement("span", {
    className: "hiddentext"
  }, placeholder)), unit && (/*#__PURE__*/_react.default.createElement("span", {
    className: `inputUnit txtText900 ${large ? 'px-2' : 'px-1'}`,
    ref: unitEl
  }, unit)))), isLoading && (/*#__PURE__*/_react.default.createElement("div", {
    className: "inputLoader"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "lds-ring"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${isLoadingColorClass}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${isLoadingColorClass}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${isLoadingColorClass}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${isLoadingColorClass}`
  })))), type === 'password' && currentValue && (/*#__PURE__*/_react.default.createElement("span", {
    className: `password-trigger ${showPasswordState ? 'active' : ''} ${large ? 'largeTop' : ''}`,
    onClick: e => toggleShowPassword(e)
  }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    className: "eye",
    icon: "eye"
  }))), meta.dirty === true && meta.invalid && showErrorState && !unit && (0, _get.default)(message, 'error', true) !== true && !isLoading && type !== 'password' && showIconValidation && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    className: `validation-icon error ${large ? 'largeTop' : ''}`,
    icon: "alert"
  })), type !== 'password' && meta.dirty === true && !meta.invalid && showErrorState && !unit && !onClear && (type !== 'number' || type === 'number' && (!minLengthNum || currentValue && +currentValue >= minLengthNum)) && !(0, _isEmpty.default)((0, _get.default)(input, 'value', null)) && !isLoading && showIconValidation && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    className: `validation-icon valid ${large ? 'largeTop' : ''}`,
    icon: "check"
  })), !disabled && onClear && !(0, _isEmpty.default)((0, _get.default)(input, 'value', null)) && !isLoading && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    onClick: e => {
      setCurrentValue('');
      onClear(e);
    },
    className: `validation-icon mt-small-2 normal cur-poi small ${large ? 'largeTop' : ''}`,
    icon: "close-circle"
  }))), !disabled && generateValue && (!generateValue.theme || generateValue.theme === 'btn') && (/*#__PURE__*/_react.default.createElement(_BrixelButtonPrimary.default, {
    onClick: () => generateValue.func(),
    className: "as-fs",
    label: generateValue.label
  }))), !disabled && generateValue && generateValue.theme === 'link' && (/*#__PURE__*/_react.default.createElement(_BrixelButtonText.default, {
    onClick: () => generateValue.func(),
    className: "as-fs",
    label: generateValue.label
  })), (0, _get.default)(message, 'help', null) || (0, _get.default)(meta, 'invalid', null) && showErrorState ? (/*#__PURE__*/_react.default.createElement("span", {
    className: `message ${(0, _get.default)(meta, 'dirty', null) && (0, _get.default)(meta, 'invalid', null) ? 'error-message' : ''} ${labelLeft ? 'ta-r' : ''}`
  }, (0, _translation.default)((errorMessage || '').toString(), lang, undefined, translations))) : (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)), modal && !modal.info && (/*#__PURE__*/_react.default.createElement("span", {
    onClick: e => modal.func ? modal.func(e) : '',
    className: `message ${modal.func ? 'cur-poi' : ''} ${modal.className || ''}`,
    dangerouslySetInnerHTML: {
      __html: modal.message || ''
    }
  }))), input.name === 'register.password' && (/*#__PURE__*/_react.default.createElement("div", {
    className: "stengthPassword"
  }, input.value && showStrongPassword && typeof input.value === 'string' && (/*#__PURE__*/_react.default.createElement("div", {
    className: "passContent"
  }, /*#__PURE__*/_react.default.createElement("meter", {
    max: "3",
    value: (0, _helper.checkPassStrength)(input.value).value.toString(),
    id: "password-strength-meter"
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "body2 mt-2-neg"
  }, (0, _translation.default)((0, _helper.checkPassStrength)(input.value).label, lang, undefined, translations)))))));
});
const mapStateToProps = state => ({
  translations: (0, _get.default)(state, 'translations', {})
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(BrixelInputText);